import React, { useMemo, memo, useCallback } from "react";

const QRSection = memo(() => {
  const apkLink = useMemo(() => {
    if (typeof window !== "undefined") {
      return `https://bunat.moad.gov.sy/download/`;
    }
    return "";
  }, []);

  const handleDownload = useCallback(() => {
    if (apkLink) {
      const link = document.createElement("a");
      link.href = apkLink;
      link.download = "bunat.apk";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [apkLink]);

  return (
    <section className="bg-landingPage lg:min-h-screen p-8 md:p-20 relative">
      {/* Decorative background image */}
      <div
        className="hidden md:block absolute inset-0 z-10"
        style={{
          backgroundImage: "url('/images/bun.png')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right top",
          backgroundSize: "auto 100%",
        }}
        aria-hidden="true"
      />
      <div className="container mx-auto max-w-5xl relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Text content */}
          <div className="flex flex-col md:items-center text-center md:text-right">
            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
              حمّل تطبيق بُناة الآن
            </h2>

            <a
              href={apkLink}
              // download="bunat.apk"
              className="
                bg-primary text-white font-semibold
                px-6 py-4
                rounded-full
                hover:bg-primary/90 active:scale-95
                transition-all duration-200
                flex items-center gap-4
                shadow-lg shadow-primary/30
                w-full max-w-sm md:w-auto mb-6
                cursor-pointer
              "
            >
              {/* <img
                src="/images/apple store.svg"
                alt="App Store"
                className="h-7 w-auto object-contain md:hidden lg:block"
                loading="lazy"
                decoding="async"
              />
              <img
                src="/images/google play.svg"
                alt="Google Play"
                className="h-7 w-auto object-contain md:hidden lg:block"
                loading="lazy"
                decoding="async"
              /> */}
              <span className="text-lg font-semibold ">
                اضغط هنا للتحميل
              </span>
            </a>

            <div className="relative flex items-center">
              <p className="text-primary font-bold hidden md:block">
                أو عن طريق رمز الاستجابة الآتي
              </p>
              <img
                src="/images/arrow.png"
                alt="Arrow"
                className="hidden xl:block absolute top-1/2 -translate-y-1/2 right-full mr-4 w-[400px] max-w-none h-auto z-10"
              />
            </div>
          </div>

          {/* Mockup */}
          <div className="hidden md:block lg:ml-[-100px]">
            <img
              src="/images/mockup4.png"
              alt="Mockup"
              className="w-[500px] h-full mx-auto" 
            />
          </div>
        </div>
      </div>
    </section>
  );
});

QRSection.displayName = "QRSection";

export default QRSection;
